<template>
  <div class="accommodation">

    <div class="title-button">

      <h1>Accommodation</h1>

      <router-link to="/accommodation/create" class="button p-3" v-if="userRole == 1">New accommodation</router-link>

    </div>

    <div class="box">

      <form @submit.stop.prevent="doSearch" class="box__header form--inline">
        <input v-model="quickSearch" type="search" placeholder="Quick search">
        <button class="button button--small" type="submit">Search</button>
      </form>

      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="doAlertEdit"
        >
      </vdtnet-table>

    </div><!-- box -->

  </div>
</template>

<script>
import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'accommodation',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'accommodation/table',
          'headers': {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
      },
      fields: {
        accommodation_name: { label: 'Name'},
        resort_name: { label: 'Resort Name' },
        supplier_name: { label: 'Supplier Name' },
        actions: {
          sortable: false,
          label: ' ',
          render: (data, type, row) => {
            return `<a href="/accommodation/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        }
      },
      quickSearch: ''
    }
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    doAlertEdit(data) {
      this.$router.push({ name: 'accommodation-edit', params: { id: data.id }})
    },
  }
}

</script>
